import { useTranslation } from "react-i18next";
import MultipleConfirmation from ".";
import { useCallback, useMemo, useState } from "react";
import {
  CheckCircleOutlined,
  CheckOutlined,
  CloseOutlined,
  ExclamationCircleFilled,
  QuestionCircleFilled,
  TeamOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Button } from "antd";
import { useCheckPermissions } from "hooks/useCheckPermissions";

const PopConfirmationAvailable = ({ adminName, isLoading, onSubmit }) => {
  const { t } = useTranslation();
  const [step, setStep] = useState(null);
  const [open, setOpen] = useState(false);
  const hasAccess = useCheckPermissions("meeting_schedule_other_admin_access");

  const okHandler = useCallback(() => {
    onSubmit(true, step.for_all_admin, () => setOpen(false));
  }, [onSubmit, step]);

  const dataContent = useMemo(() => {
    const result = [];
    if (hasAccess) {
      result.push({
        title: (
          <div className="font-bold flex gap-x-2 ">
            <QuestionCircleFilled className="text-green-500" />
            {t("meeting_management.set_available")}
          </div>
        ),
        description: t("meeting_management.set_available_desc1", {
          value: adminName,
        }),
        footer: (
          <div className="flex justify-center gap-x-2 mt-3">
            <Button
              size="small"
              icon={<TeamOutlined />}
              onClick={() => setStep({ step: 2, for_all_admin: true })}
            >
              {t("meeting_schedule.all_admins")}
            </Button>
            <Button
              size="small"
              icon={<UserOutlined />}
              onClick={() => setStep({ step: 2, for_all_admin: false })}
              type="primary"
            >
              {adminName}
            </Button>
          </div>
        ),
      });
    }

    result.push({
      title: (
        <div className="font-bold flex gap-x-2 ">
          <ExclamationCircleFilled className="text-yellow-500" />
          {t("meeting_management.set_available")}
        </div>
      ),
      description: t("meeting_management.set_available_desc", {
        value: step?.for_all_admin
          ? t("meeting_schedule.all_admins")
          : adminName,
      }),
      footer: (
        <div className="flex justify-end gap-x-2 mt-3">
          <Button
            size="small"
            icon={<CloseOutlined />}
            onClick={() => {
              setOpen(false);
              setStep(null);
            }}
            disabled={isLoading}
          >
            {t("button.no")}
          </Button>
          <Button
            size="small"
            icon={<CheckOutlined />}
            onClick={okHandler}
            type="primary"
            loading={isLoading}
          >
            {t("button.yes")}
          </Button>
        </div>
      ),
    });
    return result;
  }, [hasAccess, adminName, t, isLoading, okHandler, setOpen, setStep, step]);

  return (
    <MultipleConfirmation
      step={step}
      setStep={setStep}
      open={open}
      setOpen={setOpen}
      btnTitle={t("meeting_management.set_available")}
      data={dataContent}
      btnClass="bg-[#7bf1a8] text-black hover:bg-[#abffc8] active:bg-[#5ecc8c]"
      icon={<CheckCircleOutlined />}
    />
  );
};
export default PopConfirmationAvailable;
